/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'containsValue',
  pure: true
})
export class ContainsValuePipe implements PipeTransform {
  constructor() {}
  transform(
    arr: Array<any> | undefined,
    input: string | undefined,
    key: string | undefined
  ): boolean {
    if (arr === undefined || input === undefined || key === undefined)
      return false;

    return arr.some(value => value[key] === input);
  }
}
